import { Component } from 'react';

class DataSourceValueList extends Component {
    render() {
        return null;
    }
}

export default DataSourceValueList;